import {useCallback, useState} from 'react';
import {useStore} from 'react-redux';
import {SET_UPSELL_CONFIRMED} from '~/CreateFabricInvitation/reducers/modals';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {UPDATE_GIFT_OPTIONS} from '~/common/fabric/reducers/giftingOptions/constants';
import {UpsellModal} from '~/common/fabric/UpsellModal/UpsellModal';
import {useEventSave} from '~/OneStepCreateInvitation/hooks/useEventSave';
import {webViewPendingUpgradeToPremium} from '~/OneStepCreateInvitation/webview/webview';

export const useUpsellModal = (defaultMode) => {
  const store = useStore();
  const {autoSave} = useEventSave();

  const [upsellMode, setUpsellMode] = useState(defaultMode);
  const [upsellModalOpen, setUpsellModalOpen] = useState(false);

  const toggleUpsellModal = useCallback(
    (mode) => {
      if (mode) {
        setUpsellMode(mode);
      }
      setUpsellModalOpen(!upsellModalOpen);
    },
    [upsellModalOpen]
  );

  const upsellConfirm = useCallback(async () => {
    store.dispatch({
      type: SET_UPSELL_CONFIRMED,
      payload: true,
    });
    store.dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {isPremium: true, hideUpsell: true},
    });
    store.dispatch({
      type: UPDATE_GIFT_OPTIONS,
      payload: {
        upgraded: true,
      },
    });

    await autoSave();
    webViewPendingUpgradeToPremium(true);
    window.dataLayer.push({
      event: 'fabric_create_upgrade_gifting',
    });
  }, [store, autoSave]);

  const Component = () =>
    upsellModalOpen && (
      <UpsellModal
        noAutoRestore
        toggleUpsellModal={toggleUpsellModal}
        onConfirmAction={upsellConfirm}
        mode={upsellMode}
        closeOverlay={() => {
          webViewPendingUpgradeToPremium(false);
          toggleUpsellModal();
        }}
        upgradeToPremium={(cb) => {
          setUpsellModalOpen(false);
          cb?.();
        }}
      />
    );

  return {upsellModalOpen, toggleUpsellModal, UpsellModalComponent: Component};
};
